import GalleryTabGrid from '../common/gallery/tab_gallery/GalleryTabGrid';
import DataGalleryGridPage from '../common/gallery/tab_gallery/DataGalleryGridPage';
const Gallery = () => {
	return (
	<div>		
		<div className="section-full p-t50 p-b5  bg-repeat">
			{/* <!-- GALLERY CONTENT START --> */}
			<GalleryTabGrid demoData={DataGalleryGridPage} />
			{/* <!-- GALLERY CONTENT END --> */}
		</div>
	</div>
	);
};
export default Gallery;